/* ============================================================
   PETAL.PK — GLOBAL SCRIPT (sst-)
   Shared behaviour for sst-* sections:
   1. Reveal-on-scroll for any .sst-rv element.
   2. Sticky mobile order bar show/hide.
   Section-specific logic (PDP bundle/colour) lives in its own
   asset, not here.
   ============================================================ */
(function () {
  'use strict';

  /* ---- 1. Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sst-rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sst-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sst-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: .12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 2. Sticky bar: reveal after an anchor element scrolls past ----
     Any [data-sst-stickybar] reads its trigger from
     data-trigger (selector) + optional data-offset (px past trigger top). */
  function initStickyBar() {
    var bar = document.querySelector('[data-sst-stickybar]');
    if (!bar) return;
    var triggerSel = bar.getAttribute('data-trigger');
    var trigger = triggerSel ? document.querySelector(triggerSel) : null;
    var offset = parseInt(bar.getAttribute('data-offset') || '0', 10);

    function onScroll() {
      var past;
      if (trigger) {
        past = window.scrollY > trigger.offsetTop + offset;
      } else {
        past = window.scrollY > 600;
      }
      bar.classList.toggle('sst-show', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initReveal();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
